import { pushToWaitingList, saveLastSong } from '@redux/player';
import { PayloadAction } from '@reduxjs/toolkit';
import { Song } from 'src/@types/api-types';

import { LAST_SONG_TIMER_LENGTH_IN_MS } from 'constants/lastSong';

const sufficientTimeToPlayThisSong = (timeStamp: number | null, song: Song | null) => {
  return (
    timeStamp && song && song.length * 1000 + LAST_SONG_TIMER_LENGTH_IN_MS < timeStamp - Date.now()
  );
};

export const tryToDefineLastSong = (
  newSong: Song | null,
  currentLastSong: Song | null,
  timeStamp: number | null,
  dispatch: (action: PayloadAction<Song | Song[] | null>) => void,
) => {
  const triggerLastSongUpdate = () => {
    if (currentLastSong) {
      dispatch(pushToWaitingList([currentLastSong]));
    }
    
    dispatch(saveLastSong(newSong));
  };

  if (sufficientTimeToPlayThisSong(timeStamp, newSong)) {
    triggerLastSongUpdate();
    return true;
  }

  return false;
};
